import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import * as action from './action-types'
import * as mutation from './mutation-types'
import modules from './modules'
import webSocket from './plugins/webSocket'

Vue.use(Vuex)

const getters = {
  connected: state => state.connected,

  loading: state => state.loading > 0,

  accounts: state => state.accounts,

  selectedAccount: state => state.selectedAccount
}

const actions = {
  [action.FETCH_ACCOUNTS] ({commit}, payload = {}) {
    const keycloak = payload.keycloak || Vue.prototype.$keycloak
    const env = payload.env || Vue.prototype.$env
    const token = keycloak && keycloak.token
    const tenantId = (env && env.TENANT_ID) || (keycloak && keycloak.realm)
    const headers = token ? {Authorization: `Bearer ${token}`, 'X-Tenant-ID': tenantId} : {}
    const endpoint = `${env.MANAGER_API || ''}/me/accounts`

    function mapPolicies (p) {
      p = p || {}
      const templateLibrary = p.templateLibrary || p.templateLibraries || {}
      return {
        templateLibrary: {
          allow: templateLibrary.allow || []
        }
      }
    }

    return axios.get(endpoint, {headers})
      .then(response => {
        const accounts = [
          ...(response.data && response.data.data ? response.data.data : []).map(account => {
            return {
              accountId: account.accountId,
              name: account.name,
              policies: mapPolicies(account.policies && account.policies.webcg)
            }
          })]
        console.log('[store] Fetched accounts', JSON.parse(JSON.stringify(accounts)))
        commit(mutation.SET_ACCOUNTS, accounts)

        // Get accountId from payload, path or query parameter
        let accountId = payload.accountId || ''
        if (!accountId && typeof window !== 'undefined' && window.location) {
          if (window.location.pathname) {
            const match = window.location.pathname.match(/^\/([^/]+)/)
            if (match && match[1] && match[1] !== 'workspace') {
              accountId = decodeURIComponent(match[1])
            }
          }
          if (!accountId) {
            accountId = new URLSearchParams(window.location.search).get('accountId') || ''
          }
        }
        console.log('[store] Selected account ID', accountId)
        const account = accounts.find(account => account.accountId === accountId)
        console.log('[store] Selected account', JSON.parse(JSON.stringify(account)))
        commit(mutation.SET_SELECTED_ACCOUNT, account)

        return accounts
      })
      .catch(error => {
        console.error('[store] Failed to fetch accounts', error)
        throw error
      })
  }
}

export const mutations = {
  [mutation.SET_ACCOUNTS] (state, accounts) {
    state.accounts = accounts
  },
  [mutation.SET_SELECTED_ACCOUNT] (state, account) {
    state.selectedAccount = account
  },
  [mutation.SOCKET_CONNECTED] (state) {
    state.connected = true
  },
  [mutation.SOCKET_DISCONNECTED] (state) {
    state.connected = false
  },
  [mutation.SOCKET_LOADING] (state, {number}) {
    state.loading = number
  },
  [mutation.SOCKET_LOADED] (state) {
    state.loading = Math.max(0, state.loading - 1)
  }
}

export default new Vuex.Store({
  modules,
  state: {
    connected: false,
    loading: 0,
    accounts: null,
    selectedAccount: null
  },
  getters,
  actions,
  mutations,
  plugins: [webSocket()]
})



// WEBPACK FOOTER //
// ./src/store/index.js